/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AnonymousCommunicationBlobContentIdGet$Params {
  id: string;
}

export function anonymousCommunicationBlobContentIdGet(http: HttpClient, rootUrl: string, params: AnonymousCommunicationBlobContentIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, anonymousCommunicationBlobContentIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<string>;
    })
  );
}

anonymousCommunicationBlobContentIdGet.PATH = '/Anonymous/CommunicationBlobContent/{id}';
